export default __webpack_public_path__ + "static/media/2064.b2716740.png";